import EventEmitter from 'eventemitter3';

/**
 * @deprecated Consult with frontend chapter for better alternatives
 */
var EventBus = new EventEmitter();

export { EventBus, EventBus as default };
//# sourceMappingURL=index.js.map
